module.exports = __webpack_public_path__ + "assets/img/s4_chart-1.074a34c3.png";